import { useEffect, useState } from 'react';
const PhoneSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden
        style={{ minWidth: '48px' }}
    >
        <path
            d="M28 2H8C5.8 2 4 3.8 4 6V42C4 44.2 5.8 46 8 46H28C30.2 46 32 44.2 32 42V6C32 3.8 30.2 2 28 2ZM28 40H8V8H28V40ZM41.26 16.52C40.74 15.88 39.78 15.8 39.18 16.4L39.12 16.46C38.62 16.96 38.6 17.76 39.02 18.32C41.54 21.6 41.52 26.06 38.98 29.46C38.56 30.02 38.6 30.8 39.08 31.3L39.18 31.4C39.76 31.98 40.7 31.92 41.24 31.3C44.84 27.04 44.84 20.92 41.26 16.52ZM34.84 20.74L34.72 20.86C34.32 21.26 34.2 21.86 34.42 22.38C34.84 23.36 34.84 24.44 34.42 25.42C34.2 25.94 34.32 26.54 34.72 26.94L34.88 27.1C35.52 27.74 36.62 27.6 37.06 26.8C38.04 25.02 38.04 22.92 37.04 21.08C36.6 20.24 35.5 20.08 34.84 20.74Z"
            fill="#CF3BF5"
        />
    </svg>
);

function replacePhoneNumberWithLink(text) {
    const phoneRegex = /(\+?1?[-.\s]?)?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})/g;
    return text.replace(phoneRegex, function (match) {
        return `<a href="tel:${match.replace(/\D/g, '')}">${match}</a>`;
    });
}

function replaceMarkdownWithStrong(text) {
    return text.split(/\*\*(.*?)\*\*/g).map((part, i) => {
        // Every second part is the one that was inside the markdown syntax
        if (i % 2 === 1) {
            return <strong key={i}>{part}</strong>;
        } else {
            return part;
        }
    });
}

const ThankYou = ({ content, fallBack }) => {
    const [heading, setHeading] = useState(!content ? fallBack?.heading : null);
    const [subtext1, setSubtext1] = useState(!content ? fallBack?.subtext1 : null);
    const [subtext2, setSubtext2] = useState(!content ? fallBack?.subtext2 : null);
    const [callToAction, setCallToAction] = useState(!content ? fallBack?.callToAction : null);

    useEffect(() => {
        content?.heading && setHeading(content?.heading);
        content?.subtext1 && setSubtext1(content?.subtext1);
        content?.subtext2 && setSubtext2(content?.subtext2);
        if (typeof content?.callToAction === 'string') {
            setCallToAction({ text: content.callToAction });
        } else {
            content?.callToAction && setCallToAction(content?.callToAction);
        }
    }, [content]);

    return (
        <>
            <div className="heading-section__text">
                {heading && <h1 dangerouslySetInnerHTML={{ __html: heading }} />}
                {subtext1 && <p dangerouslySetInnerHTML={{ __html: replaceMarkdownWithStrong(subtext1) }} />}
                {subtext2 && <p dangerouslySetInnerHTML={{ __html: replaceMarkdownWithStrong(subtext2) }} />}
                {callToAction && (
                    <div className="call-to-action-container">
                        {callToAction?.type === 'phonelink-ring' && <PhoneSVG />}
                        {callToAction.text && (
                            <div
                                className="call-to-action"
                                dangerouslySetInnerHTML={{ __html: replacePhoneNumberWithLink(callToAction.text) }}
                            />
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default ThankYou;
